import React from "react";
import { Link } from "react-router-dom";
import { formatPrice } from "../../../../../../utilities/formatPrice";
import { formatDate } from "../../../../../../utilities/formatDate";
import localeText from "../../../../../../locale";
import "./EconomicCircleRecentTransactionsCard.css";

/**
 * Card "Histórico de transações" with table (up to 6 rows) and "Ver todos" link.
 * @param {Array} transactions - List of tx objects { description, type, date, amount, value }
 * @param {string} currency - Currency symbol for values
 */
const EconomicCircleRecentTransactionsCard = ({ transactions = [], currency }) => (
  <div
    className="card border-round-md p-3"
    style={{ border: "1px solid var(--theme-border, #EBEBEB)" }}
  >
    <div className="flex align-items-center justify-content-between mb-3">
      <span
        className="text-sm font-semibold"
        style={{ color: "var(--theme-text)" }}
      >
        {localeText("transactionHistory") || "Histórico de transações"}
      </span>
      <Link
        to="/dashboard-economic-circle/members?tab=transactions"
        className="text-sm font-medium"
        style={{ color: "var(--theme-primary)" }}
      >
        {localeText("viewAll") || "Ver todos"}
      </Link>
    </div>
    <div className="overflow-auto">
      {transactions.length === 0 ? (
        <p className="text-sm m-0 py-2" style={{ color: "var(--theme-text-muted)" }}>
          {localeText("noOperationsRecords") || "Nenhum registro de operação."}
        </p>
      ) : (
        <table className="w-full economic-circle-tx-table">
          <thead>
            <tr>
              <th className="text-left text-xs py-2" style={{ color: "var(--theme-text-muted)" }}>
                {localeText("origin") || "Origem"}
              </th>
              <th className="text-left text-xs py-2" style={{ color: "var(--theme-text-muted)" }}>
                {localeText("type") || "Tipo"}
              </th>
              <th className="text-left text-xs py-2" style={{ color: "var(--theme-text-muted)" }}>
                {localeText("date") || "Data"}
              </th>
              <th className="text-left text-xs py-2" style={{ color: "var(--theme-text-muted)" }}>
                {localeText("status") || "Status"}
              </th>
              <th className="text-right text-xs py-2" style={{ color: "var(--theme-text-muted)" }}>
                {localeText("value") || "Valor"}
              </th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((tx, i) => (
              <tr key={i}>
                <td className="text-sm py-1" style={{ color: "var(--theme-text)" }}>
                  {tx.description || tx.type || "-"}
                </td>
                <td className="text-sm py-1" style={{ color: "var(--theme-text-muted)" }}>
                  {tx.type || "-"}
                </td>
                <td className="text-sm py-1" style={{ color: "var(--theme-text-muted)" }}>
                  {tx.date ? formatDate(new Date(tx.date)) : "-"}
                </td>
                <td className="text-sm py-1">
                  <span
                    className="px-2 py-1 border-round text-xs"
                    style={{
                      backgroundColor: "var(--theme-primary)",
                      color: "#fff",
                    }}
                  >
                    {localeText("paid") || "Pago"}
                  </span>
                </td>
                <td className="text-sm py-1 text-right font-medium" style={{ color: "var(--theme-primary)" }}>
                  + {currency} {formatPrice(tx.amount ?? tx.value ?? 0)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  </div>
);

export default EconomicCircleRecentTransactionsCard;
